import React from 'react';
import './level1.css'
import Header from '../components/layout/header';
import pic11 from '../assets/pic11.png'
import pic48 from '../assets/pic48.png'
import Settings from '../components/common/settings';
import pic50 from '../assets/pic50.png'
import pic51 from '../assets/pic51.png'
import pic52 from '../assets/pic52.png'
import pic53 from '../assets/pic53.png'
import pic55 from '../assets/pic55.png'
import pic56 from '../assets/pic56.png'
import pic54 from '../assets/pic54.png'
import pic57 from '../assets/pic57.png'
import pic58 from '../assets/pic58.png'
import pic59 from '../assets/pic59.png'
import pic60 from '../assets/pic60.png'
import pic61 from '../assets/pic61.png'
import pic62 from '../assets/pic62.png'
import pic63 from '../assets/pic63.png'
import pic64 from '../assets/pic64.png'
import pic67 from '../assets/pic67.png'
import pic68 from '../assets/pic68.png'
import pic69 from '../assets/pic69.png'
import pic70 from '../assets/pic70.png'
import pic71 from '../assets/pic71.png'
import pic72 from '../assets/pic72.png'
import pic73 from '../assets/pic73.png'
import pic81 from '../assets/pic81.png'
import pic74 from '../assets/pic74.png'
import pic75 from '../assets/pic75.png'
import pic76 from '../assets/pic76.png'
import pic77 from '../assets/pic77.png'
import pic78 from '../assets/pic78.png'
import pic79 from '../assets/pic79.png'
import pic80 from '../assets/pic80.png'
import AudioContext from '../components/common/AudioContext';
import yourmission from '../audio/yourmission.mp3';
import pic35 from '../assets/pic35.png'
import './howtoplayinstructions.css'
import Primaryctashort from '../components/common/primaryshortcta';
import Secondaryctashort from '../components/common/secondaryshort';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './Misson.css'
import { useEffect } from 'react';
import { useState } from 'react';

const Misson = ({ onClose }) => {
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [closing, setClosing] = useState(false);
    const { soundVolume } = React.useContext(AudioContext);
    const audioRef = React.useRef(null);
     const navigate = useNavigate();

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;
        audio.volume = soundVolume;
        audio.play().catch(() => {});

        return () => {
            audio.pause();
            audio.currentTime = 0;
        };
    }, []);

    useEffect(() => {
        if (audioRef.current) audioRef.current.volume = soundVolume;
    }, [soundVolume]);


const handleBack = () => {
  setClosing(true);
  setTimeout(() => navigate('/Howtoplayinstructions', { state: { back: true } }), 400);
};
const handleStart = () => {
  setClosing(true);
  setTimeout(() => navigate('/Level1start'), 400);
};

    return ( 
        <>
<main className='level1--page'>
            <section className='levelbackground--page'>
                 {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
 <>
          <audio ref={audioRef} src={yourmission} preload="auto" />

               <section className='settings-background'>
            <section className={`mission-overlay ${closing ? 'slide-down' : 'slide-up'}`}>

                <section className='header-overlay'>
                    <div className='header-title-cont-settings'>
                        <h2 className='title-containerr-settings'>Mission</h2>
                        <h2 className='title2-container-settings'>Mission</h2>
                    </div>
                    
                        <button className='circlecta-cont' >
                         <div onClick={handleStart}>
                            <div className='circle-red'>
                                <img className='close-img' src={pic35} alt='close'></img>
                            </div>
                        </div>
                    </button>
                </section>


                <section className='container-mission'>
                    <section className='container-audio'>

                        <p className='para-mission'>Collect artifacts and reach the end
                             to save the temple and unlock new levels.</p>

                    </section>
                </section>



                <div className='container-continue-how-to-play' >
                    <div onClick={handleBack}>
                        <Secondaryctashort  title='Back'/>
                    </div>
                     <div onClick={handleStart}>
                    <Primaryctashort title='Next' />
                    </div>
                 
                </div>



                </section>
            </section>
        </>
                <div className='background-and-obstacles-layer2'>
                    <div className='container-obtsacles-and-collections'>
                        <img className='obstacle1' src={pic57} alt='obstacle-1'/>
                        <img className='obstacle2' src={pic58} alt='obstacle-2'/>
                        <img className='obstacle3' src={pic59} alt='obstacle-3'/>
                        <img className='obstacle4' src={pic60} alt='obstacle-4'/>
                        <img className='obstacle5' src={pic61} alt='obstacle-5'/>
                        <img className='collect1' src={pic62} alt='collect-1'/>  
                        <img className='obstacle6' src={pic63} alt='obstacle-6'/>  
                        <img className='obstacle7' src={pic64} alt='obstacle-7'/>   
                        <img className='obstacle8' src={pic67} alt='obstacle-8'/>                          
                        <img className='obstacle9' src={pic68} alt='obstacle-9'/>  
                        <img className='obstacle10' src={pic69} alt='obstacle-10'/>  
                        <img className='obstacle11' src={pic70} alt='obstacle-11'/>  
                        <img className='obstacle12' src={pic71} alt='obstacle-12'/>  
                        <img className='obstacle13' src={pic72} alt='obstacle-12'/> 
                        <img className='obstacle14' src={pic73} alt='obstacle-14'/> 
                        <img className='obstacle15' src={pic81} alt='obstacle-14'/> 
                        <img className='obstacle16' src={pic74} alt='obstacle-14'/> 
                        <img className='obstacle17' src={pic75} alt='obstacle-17'/> 
                        <img className='obstacle18' src={pic76} alt='obstacle-18'/> 
                        <img className='obstacle19' src={pic77} alt='obstacle-19'/>  
                        <img className='obstacle20' src={pic78} alt='obstacle-20'/>                            
                        <img className='obstacle21' src={pic79} alt='obstacle-20'/> 
                        <img className='obstacle22' src={pic80} alt='obstacle-20'/> 

                    </div>
                </div>


             {/* <section className='container-items-home-page'>
               <section className='container-charcater-page'>
                    </section>
              </section> */}
   
                <section className='container-hedaer-and-character-levels-page'>
                    <Header 
                    title='Level 1' title2='Level 1 '
                    link='/home'  onClick={() => setSettingsOpen(true)}
                    img={pic48} icontext='pause icon'
                    img2={pic11} icontext2='settings icon'/>
                 <img className='character-movement' src={pic54} alt='character'></img>




                    <div className='HUD-container'>

                            <div className='lives-frame-Hud'>
                                <div className='lives-container-HUD'>
                                    <img className='decoration2-HUD' src={pic56} alt='decoration-HUD'></img>
                                    <div className='hearts-container'>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                        <img src={pic53} alt='heart'></img>
                                    </div>
                                </div>
                            </div>

                        <div className='frame-Hud'>
                            <div className='HUD-1-container'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>

                                <h2 className='collect-text'>Collect:</h2>
                                <div className='row-pic-HUD'>
                                    <div className='img-container-HUD'> 
                                        <img src={pic50} alt='collect-item-1'></img>
                                    </div>

                                    <div className='img-container-HUD'> 
                                        <img src={pic51} alt='collect-item-1'></img>
                                    </div>


                                    <div className='img-container-HUD'> 
                                        <img src={pic52} alt='collect-item-1'></img>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>



                </section>
            </section>
          </main>

         </>
     );
}
 
 
export default Misson;